
            const data = {"name":"feather/credit-card","data":{"width":"24","height":"24","viewBox":"0 0 24 24","data":"<rect pid=\"0\" x=\"1\" y=\"4\" width=\"22\" height=\"16\" rx=\"2\" ry=\"2\"/><path pid=\"1\" d=\"M1 10h22\"/>","originalColors":[],"stopColors":[]}}
        
                module.exports = data
                